module.exports = __webpack_public_path__ + "static/media/account-feature-news.28ae6d64.png";